/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';
import WindIndicator from '../WindIndicator/WindIndicator.js';
import PlayMarker from '../icons/PlayMarker/PlayMarker.js';

const SpotThumbnail = ({
  windDirection,
  windSpeed,
  units,
  hasCamera
}) => /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-thumbnail"
}, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-thumbnail__top-container"
}, /*#__PURE__*/React.createElement(WindIndicator, {
  direction: windDirection,
  speed: windSpeed,
  units: units.windSpeed
})), /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-thumbnail__bottom-container"
}, hasCamera ? /*#__PURE__*/React.createElement(PlayMarker, null) : null));

SpotThumbnail.defaultProps = {
  hasCamera: false
};

export default SpotThumbnail;
//# sourceMappingURL=SpotThumbnail.js.map
